export const AUTH_TYPE_DIRECT = 'DIRECT'
export const AUTH_TYPE_PIN = 'PIN'
